class DocumentationController implements ng.IComponentController {
    height: number;
    scrollY: number;
    constructor(
    ) {
        'ngInject';
        // console.log('DocumentationController');
    };    
}

export const documentationComponent: ng.IComponentOptions = {
    controller: DocumentationController,
    template: require('./documentation.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/documentation/documentation.component.ts